import { sendPostMessage, MessageType } from '../../lib/sendPostMessage';
import { Wws_Page, Wws_PageItem } from '../../types/graphql';
import TrashCan from '../svgs/TrashCan';
import {
  InlineEditContextMenuButton,
  buildEditButton,
} from './InlineEditContextMenu/InlineEditContextMenu';

export const buildEditCoverPhotoContextMenuButtons =
  (): InlineEditContextMenuButton[] => {
    return [
      buildEditButton(() =>
        sendPostMessage({
          type: MessageType.EDIT_COVER_PHOTO,
          data: undefined,
        })
      ),
    ];
  };

export const buildEditBasicInfoContextMenuButtons = (
  fieldId?: string
): InlineEditContextMenuButton[] => {
  return [
    buildEditButton(() =>
      sendPostMessage({
        type: MessageType.EDIT_BASIC_INFO,
        data: { fieldId },
      })
    ),
  ];
};

export const buildEditCoupleNameContextMenuButtons = (
  fieldId?: string
): InlineEditContextMenuButton[] => {
  return [
    buildEditButton(() =>
      sendPostMessage({
        type: MessageType.EDIT_COUPLE_NAME,
        data: { fieldId },
      })
    ),
  ];
};

export const buildEditDateLocationContextMenuButtons = (
  fieldId?: string
): InlineEditContextMenuButton[] => {
  return [
    buildEditButton(() =>
      sendPostMessage({
        type: MessageType.EDIT_DATE_LOCATION,
        data: { fieldId },
      })
    ),
  ];
};

export const buildPageItemEditButton = (
  page: Wws_Page,
  item: Wws_PageItem,
  pageItemSubItemId?: number | string
): InlineEditContextMenuButton => {
  return buildEditButton(() =>
    sendPostMessage({
      type: MessageType.EDIT_PAGE_ITEM,
      data: {
        pageId: page.id,
        pageItemId: item.id,
        pageItemType: item.type,
        pageItemSubItemId,
      },
    })
  );
};

export const buildEditPageItemContextMenuButtons = (
  page: Wws_Page,
  item: Wws_PageItem,
  pageItemSubItemId?: number | string
): InlineEditContextMenuButton[] => {
  return [
    buildPageItemEditButton(page, item, pageItemSubItemId),
    {
      icon: <TrashCan />,
      label: 'Delete',
      onClick: () =>
        sendPostMessage({
          type: MessageType.DELETE_PAGE_ITEM,
          data: {
            pageId: page.id,
            pageItemId: item.id,
            pageItemType: item.type,
            pageItemSubItemId,
          },
        }),
    },
  ];
};

export const buildEditPageTitleContextMenuButtons = (
  page: Wws_Page
): InlineEditContextMenuButton[] => {
  return [
    buildEditButton(() =>
      sendPostMessage({
        type: MessageType.EDIT_PAGE_TITLE,
        data: { pageId: page.id },
      })
    ),
  ];
};

export const buildEditAnnouncementBannerContextMenuButtons = (): InlineEditContextMenuButton[] => {
  return [
    buildEditButton(() =>
      sendPostMessage({
        type: MessageType.EDIT_ANNOUNCEMENT_BANNER,
        data: undefined,
      })
    ),
  ];
};
